import { useMemo } from "react";
import { CohortCard, type CohortCardData } from "./CohortCard";
import type { ToolUIProps } from "./ToolUIContext";

export function parseCohort(result: string | undefined): CohortCardData | null {
  if (!result) return null;
  try {
    const parsed = JSON.parse(result);
    // create_cohort and update_cohort wrap the response: { cohort: {...}, filters_applied: bool }
    // get_cohort returns the cohort object directly — unwrap either shape
    return ((parsed?.cohort ?? parsed) as CohortCardData) || null;
  } catch {
    return null;
  }
}

function Skeleton() {
  return (
    <div className="overflow-hidden rounded-xl border-2 border-primary/60 bg-card animate-pulse">
      <div className="px-4 pt-4 pb-2 flex justify-between">
        <div className="space-y-1.5">
          <div className="h-4 w-40 rounded bg-muted" />
          <div className="h-3 w-56 rounded bg-muted" />
        </div>
        <div className="h-3 w-12 rounded bg-muted" />
      </div>
      <div className="px-4 pb-4">
        <div className="h-8 w-28 rounded bg-muted" />
      </div>
    </div>
  );
}

function CohortToolUI({ result, isRunning }: ToolUIProps) {
  const cohort = useMemo(() => parseCohort(result), [result]);
  if (cohort) return <CohortCard cohort={cohort} />;
  if (isRunning) return <Skeleton />;
  return null;
}

export const CohortGetToolUI = CohortToolUI;
export const CohortUpdateToolUI = CohortToolUI;
export const CohortCreateToolUI = CohortToolUI;
